import { API_ENDPOINTS } from '@/api/endpoints';
import { Area } from '@/stores/SubprojectStore';
import { apiFetch } from '@/util/apiClient';
import { useQuery } from '@tanstack/react-query';
import { PlugLoad, PlugLoadWithMetrics } from '../types';
import { addMetricsToResource } from './techMetrics';

export const usePlugLoadWithMetrics = (conditionedSpaceArea?: Area) => {
  return useQuery<PlugLoad[], Error, PlugLoadWithMetrics[]>({
    queryKey: ['plugload', 'withMetrics', conditionedSpaceArea?.value],
    queryFn: () =>
      apiFetch<PlugLoad[]>(API_ENDPOINTS.COMMON.technology.plugload),
    enabled: conditionedSpaceArea !== undefined,
    select: (data) => addMetricsToResource(data, conditionedSpaceArea),
  });
};
